import { render, staticRenderFns } from "./scope27.vue?vue&type=template&id=bdf7125a&scoped=true"
import script from "./scope27.vue?vue&type=script&lang=js"
export * from "./scope27.vue?vue&type=script&lang=js"
import style0 from "./scope27.vue?vue&type=style&index=0&id=bdf7125a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdf7125a",
  null
  
)

export default component.exports